import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	sideCard: {
		'& .MuiBox-root ': {
			display: 'flex',
			flexDirection: 'column',
			padding: theme.spacing(0, 0, 2, 0),
		},
		fullWidth: {
			display: 'inline',
			position: 'absolute',
		},
	},
	switch: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingTop: '0.875rem',
	},
	divider: {
		margin: theme.spacing(2, 0, 3, 0),
	},
}));
